import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const BitbotError = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M8 2.79999C8.41421 2.79999 8.75 2.4642 8.75 2.04999C8.75 1.63577 8.41421 1.29999 8 1.29999C7.58579 1.29999 7.25 1.63577 7.25 2.04999C7.25 2.4642 7.58579 2.79999 8 2.79999Z"
      fill="currentColor"
    />
    <path
      d="M7.03039 8.03033L6.31072 8.75L7.03039 9.46967L5.96973 10.5303L5.25006 9.81066L4.53039 10.5303L3.46973 9.46967L4.1894 8.75L3.46973 8.03033L4.53039 6.96967L5.25006 7.68934L5.96973 6.96967L7.03039 8.03033Z"
      fill="currentColor"
    />
    <path
      d="M11.8107 8.75L12.5304 8.03033L11.4697 6.96967L10.7501 7.68934L10.0304 6.96967L8.96973 8.03033L9.6894 8.75L8.96973 9.46967L10.0304 10.5303L10.7501 9.81066L11.4697 10.5303L12.5304 9.46967L11.8107 8.75Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0675 3.75502C9.55622 3.57673 6.4436 3.57673 3.93235 3.75502C2.7069 3.84202 1.73302 4.76064 1.51474 5.94078C1.13968 7.96854 0.89912 9.57074 0.800766 11.2806C0.718305 12.7142 1.81029 13.9177 3.23306 14C6.02784 14.1617 9.97195 14.1617 12.7667 14C14.1895 13.9177 15.2815 12.7142 15.199 11.2806C15.1007 9.57074 14.8601 7.96855 14.4851 5.94078C14.2668 4.76064 13.2929 3.84202 12.0675 3.75502ZM4.03858 5.25125C6.4791 5.07798 9.52072 5.07798 11.9612 5.25125C12.4769 5.28786 12.9109 5.67734 13.0101 6.21359C13.3805 8.21639 13.6084 9.74815 13.7015 11.3667C13.7358 11.9627 13.2868 12.4674 12.6801 12.5025C9.94302 12.6609 6.05678 12.6609 3.31971 12.5025C2.71298 12.4674 2.26401 11.9627 2.29829 11.3667C2.39139 9.74815 2.61928 8.21639 2.98972 6.21359C3.08891 5.67733 3.52291 5.28786 4.03858 5.25125Z"
      fill="currentColor"
    />
  </Icon>
));

export default BitbotError;
